/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_LegalInputs */

const cs_templates_kind_legal = /** @type {(inputs: Templates_Kind_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní dokument`)
};

const en_templates_kind_legal = /** @type {(inputs: Templates_Kind_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal document`)
};

/**
* | output |
* | --- |
* | "Legal document" |
*
* @param {Templates_Kind_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_legal = /** @type {((inputs?: Templates_Kind_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_legal(inputs)
	return cs_templates_kind_legal(inputs)
});